import React, {cloneElement} from 'react';
import classnames from 'classnames';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {landScapeResponsive, responsive, customizeMargin} from './config';
import _get from 'lodash/get';
import {useTranslation} from 'react-i18next';
import {
  getActionButtonColor,
  getPrimaryColor,
  getSecondary2Color,
  getSecondaryColor,
} from '../../config/utils/commonUtils';
import {ReactComponent as ScaleSetSVG} from '../../../../../assets/images/skincare/simulation/scale_set.svg';

export default function SimulationDisplaySection({
  commonData = {},
  facialZones,
  selectedFacialZone,
  setSelectedFacialZones,
  treatmentOptions,
  selectTreatment,
  setSelectTreatment,
  isLandscape,
  language,
  slider,
}) {
  const {t} = useTranslation();
  const customizeFont = ['ja', 'fr', 'es'];
  const actionButtonColor = getActionButtonColor(commonData);
  const primaryColor = getPrimaryColor(commonData);
  const secondaryColor = getSecondaryColor(commonData);
  const secondary2Color = getSecondary2Color(commonData);

  return (
    <div className="simulationpreview-display-section">
      <div
        className={classnames({
          'simulationpreview-archbase': true,
          'simulationpreview-archbase-landscape': isLandscape,
        })}
      >
        {facialZones.map((zone, index) => {
          const i = facialZones.length - 1;
          const margin = customizeMargin[`${i}`][index] || '7px';
          return (
            <div
              className={classnames({
                'simulationpreview-facialzones-selector': true,
                'simulationpreview-facialzones-selector-zone':
                  zone.value !== selectedFacialZone.value,
                'simulationpreview-facialzones-selector-zone-selected':
                  zone.value === selectedFacialZone.value,
                'cursor-pointer': true,
              })}
              style={{
                marginLeft: margin,
              }}
              onClick={() => {
                setSelectedFacialZones(zone);
                setSelectTreatment(
                  treatmentOptions.find(t => t.type === zone.value)
                );
                const index = treatmentOptions.findIndex(
                  tt =>
                    tt.value ===
                    treatmentOptions.filter(t => t.type === zone.value)[0].value
                );
                slider && slider.current && slider.current.goToSlide(index);
              }}
            >
              <div
                className={classnames({
                  'simulationpreview-facialzones-selector-img-outline': true,
                  'simulationpreview-facialzones-selector-img-outline-landscape': isLandscape,
                })}
              >
                <div
                  className={classnames({
                    'simulationpreview-facialzones-selector-img': true,
                    'simulationpreview-facialzones-selector-img-landscape': isLandscape,
                  })}
                >
                  {zone.icon_svg &&
                    cloneElement(zone.icon_svg, {
                      fill:
                        zone.value === selectedFacialZone.value
                          ? primaryColor
                          : '#333',
                    })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="text-right">
        <b
          className="simulationpreview-button"
          style={{backgroundColor: actionButtonColor}}
        >
          {t('p.s.c.s.preview.view Treatments', {
            defaultValue: 'View Treatments',
            lng: language.i18n,
          })}
          <i className="fa fa-angle-double-right" />
        </b>
      </div>
      <div
        className={classnames({
          'simulationpreview-scale': true,
          'simulationpreview-scale-landscape': isLandscape,
        })}
      >
        <ScaleSetSVG fill={primaryColor} />
        <div className="simulationpreview-choose-section">
          <div className="simulationpreview-treatment-selector">
            <Carousel
              key={`carousel-${isLandscape}`}
              responsive={isLandscape ? landScapeResponsive : responsive}
              arrows={false}
              showDots={false}
              slidesToSlide={3}
              infinite={false}
              autoPlay={false}
              focusOnSelect={true}
              ssr={true}
              autoPlaySpeed={1000}
              additionalTransfrom={3}
              minimumTouchDrag={5}
              keyBoardControl={true}
              customTransition="all .5"
              transitionDuration={500}
              containerClass="carousel-container"
              removeArrowOnDeviceType={['tablet', 'mobile']}
              ref={slider}
            >
              {[...Array(isLandscape ? 4 : 2)].map((_, i) => (
                <div key={i} className="treatment-selector-item" />
              ))}
              {treatmentOptions.map((ts, index) => (
                <div className="d-flex align-items-center">
                  {index > 0 &&
                    treatmentOptions[index - 1].type !==
                      treatmentOptions[index].type && (
                      <div
                        style={{
                          height: '60px',
                          borderLeft: '1px solid #BABFD4',
                          margin: '0 5px 0 5px',
                        }}
                      />
                    )}
                  <div
                    className={classnames({
                      'simulationpreview-treatment-selector-item': true,
                      'simulationpreview-treatment-selector-item-landscape': isLandscape,
                    })}
                    onClick={() => {
                      setSelectTreatment(ts);
                      setSelectedFacialZones(
                        facialZones.find(r => r.value === ts.type)
                      );
                      slider &&
                        slider.current &&
                        slider.current.goToSlide(index);
                    }}
                    style={{
                      marginTop:
                        ts.value === selectTreatment.value && isLandscape
                          ? '2px'
                          : '4px',
                    }}
                  >
                    <div
                      className={classnames({
                        'simulationpreview-treatment-selector-item-img': true,
                        'simulationpreview-treatment-selector-item-img-selected':
                          ts.value === selectTreatment.value,
                        'simulationpreview-treatment-selector-item-img-landscape': isLandscape,
                        'simulationpreview-treatment-selector-item-img-selected-landscape':
                          ts.value === selectTreatment.value && isLandscape,
                      })}
                      style={{
                        border:
                          ts.value === selectTreatment.value &&
                          `2px solid ${primaryColor}`,
                        backgroundColor:
                          ts.value === selectTreatment.value
                            ? secondaryColor
                            : secondary2Color,
                      }}
                    >
                      <img src={ts.icon} alt="" />
                    </div>
                    <div
                      className={classnames({
                        'simulationpreview-treatment-selector-item-text': true,
                        'simulationpreview-treatment-selector-item-text-landscape': isLandscape,
                        'simulationpreview-treatment-selector-item-text-selected':
                          ts.value === selectTreatment.value,
                        'simulationpreview-facialzones-customizefont1':
                          customizeFont.includes(language.i18n) &&
                          facialZones.length === 4,
                        'simulationpreview-facialzones-customizefont2':
                          customizeFont.includes(language.i18n) &&
                          facialZones.length > 4,
                      })}
                      style={{
                        color:
                          ts.value === selectTreatment.value && primaryColor,
                      }}
                    >
                      {ts.customName ||
                        t(
                          _get(
                            ts,
                            'i18n',
                            'p.p.webmodule.configuration.layout.default'
                          ),
                          {
                            lng: language.i18n,
                          }
                        )}
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
}
